import React from "react";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { CCard } from "@coreui/react";
import { useTranslation } from "react-i18next";
import "./NotificationCard.css";
import IconButton from "@mui/material/IconButton";
import { FaInfoCircle } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";

const NotificationCard = ({ title, body, timestamp, loading, tooltipInfo }) => {
  const { t } = useTranslation();

  const handleTimestamp = (ts) => {
    let not_date = new Date(ts*1000);
      let day = not_date.getDate();
      let month = not_date.getMonth() + 1
      let year = not_date.getFullYear()
      let hours = not_date.getHours()
      let minutes = not_date.getMinutes()

      let string_date = undefined

      if( t("patientInformation") === "Informazioni Paziente" )
        string_date = `${day > 9 ? day : '0'+day }-${month > 9 ? month : '0'+month}-${year}_${hours > 9 ? hours : '0'+hours}:${minutes > 9 ? minutes : '0'+minutes }`
      
      else{
        let am_pm = undefined

        let h12 = hours%12 === 0 ? 12 : hours%12
        if(hours >= 12)
          am_pm = 'PM'
        else
          am_pm = 'AM'

        // string_date = `${month > 9 ? month : '0'+month}-${day > 9 ? day : '0'+day}-${year}_${h12}:${minutes > 9 ? minutes : '0'+minutes } ${am_pm}`
        string_date = `${day > 9 ? day : '0'+day}-${month > 9 ? month : '0'+month}-${year}_${h12}:${minutes > 9 ? minutes : '0'+minutes } ${am_pm}`
      }

      return string_date
  }

  return (
    <CCard className="background-card-list">
      {!loading && (
        <>
          <div className="div-row">
            <Tooltip
              title={<span className="tooltip-window">{tooltipInfo}</span>}
              arrow
            >
              <IconButton>
                <FaInfoCircle className="info-icon-list" />
              </IconButton>
            </Tooltip>
          </div>
          <h3>{t("educationalNotificationCardTitle")}</h3>  

          { title !== "" &&
          <>  
          <div className="slide-header">
              <div className="header">
                <h6>{title}</h6>
              </div>
          </div>   

          <div className="content">
            <p style={{textAlign: "justify"}}>
                { body }
            </p>
          </div>

          <div className="date-div">
            <p>
                { handleTimestamp(timestamp).split('_')[0] }
            </p>
            <p>
                { handleTimestamp(timestamp).split('_')[1] }
            </p>
          </div>
          </>}
          
          {
              title === "" && (
                  <>
                    {
                        <div className="center-content-italic">
                          <p>{t("no_educationalNotificationTitle")}</p>
                        </div>
                    }
                  </>
              )
          }
        </>
      )}
      {/* {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <ClipLoader
            color="white"
            loading={loading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )} */}
    </CCard>
  );
};

NotificationCard.propTypes = {
//   lifestyle: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  tooltipInfo: PropTypes.string.isRequired,
};
export default NotificationCard;
